import { memo, useState } from "react";
import Icon from "components/Elements/Icon/Icon";
import { useProfile } from "contexts/profileContext/profileContext";
import { useContent } from "contexts/contentContext/contentContext";

const SearchBar = memo(() => {
  const { getTextByKey } = useContent();
  const [search, setSearch] = useState("");
  const { setSearchTerm, getLoading, setCurrentPage } = useProfile();

  const handleSearch = (e: any) => {
    e.preventDefault();

    setSearchTerm(encodeURIComponent(search?.trim()));
    setCurrentPage(1);
  };

  const clearSearch = () => {
    setSearch("");
    setSearchTerm("");
    setCurrentPage(1);
  };

  return (
    <form onSubmit={handleSearch} className="search-form">
      <input
        type="text"
        className="search-bar"
        placeholder={getTextByKey("sub-users-search")}
        value={search}
        onChange={({ target }) => setSearch(target.value)}
      />
      {!!search?.length && (
        <Icon
          name="x"
          gray
          alt="reset search"
          onClick={clearSearch}
          iconClass="reset"
        />
      )}
      <div className="search-icon" onClick={handleSearch}>
        <Icon name="search" gray alt="search" />
      </div>
    </form>
  );
});

export default SearchBar;
